import { render, staticRenderFns } from "./TheoryLessonDetails.vue?vue&type=template&id=284e7320"
import script from "./TheoryLessonDetails.vue?vue&type=script&lang=ts"
export * from "./TheoryLessonDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports